import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TacticsPage from './pages/TacticsPage';
import OTTPage from './ott/OTTPage';
import './App.css';

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Home Page */}
        <Route path="/" element={<HomePage />} />

        {/* New team creation (no ID yet) */}
        <Route path="/roster" element={<TacticsPage defaultTab="roster" />} />
        <Route path="/tactics" element={<TacticsPage defaultTab="tactics" />} />

        {/* Load existing team — ID in URL so refresh/deep-link works */}
        <Route path="/roster/:teamId" element={<TacticsPage defaultTab="roster" />} />
        <Route path="/tactics/:teamId" element={<TacticsPage defaultTab="tactics" />} />

        {/* OTT Simulator Page */}
        <Route path="/ott" element={<OTTPage />} />

        {/* Fallback for undefined routes */}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </Router>
  );
}
